module.exports = __webpack_public_path__ + "static/media/image_16.141c2dc5.png";